import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';

import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppTokenService } from '../../../app-token.service';
import { MenuItemService } from './menu-item.service';
import { MenuItemStore } from './menu-item.store';
import { MenuItemQuery } from './menu-item.query';
import { Observable, of } from 'rxjs';
import { MenuItemModel } from './menu-item.model';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MenuItemFacade extends BaseFacade {

  constructor(
    private readonly menuItemService: MenuItemService,
    menuItemStore: MenuItemStore,
    menuItemQuery: MenuItemQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(menuItemService,
      menuItemStore,
      menuItemQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade(AppTokenService.MENU_ITEM_SCHEMA_NAME),
      translateService,
      AppTokenService.MENU_ITEM_SCHEMA_NAME + '-facade'
      );
  }

  getMenuItemsByParentId(id: string): Observable<MenuItemModel[]> {
    return this.menuItemService.getByParentId(id, 'parentMenuItem', 'data/index/iv').pipe(map((contentList) => {
      return contentList.items;
    }));

  }

  getMenuItemsByPageId(id: string): Observable<MenuItemModel[]> {
    return this.menuItemService.getByParentId(id, 'page', 'data/index/iv').pipe(map((contentList) => {
      return contentList.items;
    }));
  }

  getMenuItemsOrdered(ids: string[], orderBy: string): Observable<MenuItemModel[]> {
    return this.getService().getContentByIds(ids, orderBy);
  }

}
